import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AccountService } from '../services/account.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import {licenseMap, ReSentActivationMailMsg} from '../shareModel';
import {marker as TRANSLATE} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-resend-activation-mail',
  templateUrl: './resend-activation-mail.component.html',
  styleUrls: ['./resend-activation-mail.component.css']
})
export class ResendActivationMailComponent implements OnInit, OnDestroy {
  recaptcha: any;
  captchaError = false;
  loginEmail: string;
  private componentDestroyed = new Subject();
  Msg = '';
  displayResetDialog = false;
  constructor(private router: Router, private ngxService: NgxUiLoaderService,
              private apiService: AccountService, private translateService: TranslateService) {}

  ngOnInit() {
    this.ngxService.start();
    this.recaptcha = (window as any).grecaptcha;
    setTimeout(() => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-login');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    this.ngxService.stop();
    },500)
  }

  sendEmail(e) {
    this.ngxService.start();
    this.captchaError = !this.recaptcha.getResponse();
    if (e.valid && this.recaptcha.getResponse()) {
      this.apiService.ReSendActivationMail(e.value.loginEmail).subscribe(res => {
        this.ngxService.stop();
        setTimeout(() => {
          const code = parseInt(res.Message, 10);
          if (ReSentActivationMailMsg.hasOwnProperty(code)) {
            this.Msg = this.translateService.instant(ReSentActivationMailMsg[code], {Default: ReSentActivationMailMsg[code]});
          } else {
            this.Msg = this.translateService.instant(TRANSLATE('Update Fail'));
          }
          this.displayResetDialog = true;
        }, 500);
        // this.router.navigate(['/login']);
      });
    } else {
      this.ngxService.stop();
    }
  }

  closeDialog() {
    this.router.navigate(['/login']);
    this.displayResetDialog = false;
  }

  reCaptchaResolve(event) {
    // console.log('resolve', event);
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

}
